import { Http } from '../../shared';
import { settings } from '../../settings';

export class CheckoutService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }

    async create(data) {
        var response = await this.http.post(this.service_url + '/checkouts', data);
        return response.data;
    }



    async initPayment(token, data) {
        var response = await this.http.post(`${this.service_url}/checkouts/${token}/payments`, data);
        return response.data;
    }


    async complete(token, data) {
        var response = await this.http.post(`${this.service_url}/checkouts/${token}/complete`, data);
        return response.data;
    }
}
